import { createRouter, createWebHistory } from 'vue-router'

import RegisterForm from '../components/RegisterForm.vue'
import LoginForm from '../components/LoginForm.vue'
import ForgotPassword from '../components/ForgotPassword.vue'
import ChangePassword from '../components/ChangePassword.vue'
import UbahPassword from '../components/UbahPassword.vue'
import ActivationForm from '../components/ActivationForm.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
import UserProfile from '@/pages/UserProfile.vue'
import AdminWeb from '../components/AdminWebForm.vue'
import DataWarga from '../components/DataWarga.vue'

const routes = [
  { path: '/', name: 'Login', component: LoginForm },
  { path: '/register', name: 'Register', component: RegisterForm },
  { path: '/forgotpassword', name: 'ForgotPassword', component: ForgotPassword },
  { path: '/changepassword', name: 'ChangePassword', component: ChangePassword },
  { path: '/ubahpassword', name: 'UbahPassword', component: UbahPassword },
  { path: '/activate', name: 'Activate', component: ActivationForm },
  { path: '/dashboard', component: DashboardPage },
  { path: '/profile', component: UserProfile },
  { path: '/adminweb', name: 'AdminWeb', component: AdminWeb },
  { path: "/datawarga", name: "DataWarga", component: DataWarga}
]

const router = createRouter({
  history: createWebHistory(), // ✅ This requires correct server config!
  routes
})

export default router
